import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import usePrintOnDemandeProduct from 'hooks/queries/printOndemandeProducts/usePrintOnDemandeProduct';

const usePrintingInfoModals = () => {
  const { openModal } = useModal();
  const { data: pricingGrid } = usePrintOnDemandeProduct();

  const openPricingGridModal = () => {
    if (!pricingGrid) {
      return;
    }

    openModal(MODAL_NAME.PRICING_OFFERS, {
      offers: pricingGrid.data['hydra:member'],
      title: 'printing-price',
      submitLabel: 'understood',
    });
  };

  const openOnboardingModal = () => {
    openModal(MODAL_NAME.CMS_MODAL, {
      cmsModalName: 'printing-order-onboarding',
    });
  };

  const openPrintingSlotInfoModal = () =>
    openModal(MODAL_NAME.CMS_MODAL, {
      cmsModalName: 'printing-slot-information',
    });

  const openExistingDraftOrderWarningModal = () =>
    openModal(MODAL_NAME.CMS_MODAL, {
      cmsModalName: 'printing-existing-draft-order-warning',
    });

  return {
    openPricingGridModal,
    openOnboardingModal,
    openPrintingSlotInfoModal,
    openExistingDraftOrderWarningModal,
  };
};

export default usePrintingInfoModals;
